<template>
	<div v-if="lockMessage" class="field is-flex is-align-content-center mt-1">
		<i class="fa-solid fa-info-circle"></i>
		<span class="is-size-7 is-capitalized has-text-weight-normal ml-1">{{ lockMessage }}</span>
	</div>
</template>

<script>
export default {
	props: ['capsLockMessage', 'numLockMessage', 'idTarget'],
	data() {
		return {
			isCapsLockOn: false,
			isNumLockOn: false,
		};
	},
	computed: {
		lockMessage() {
			if (this.isCapsLockOn) {
				return this.capsLockMessage;
			} else if (this.isNumLockOn) {
				return this.numLockMessage;
			}
			return null;
		}
	},
	mounted() {
		window.addEventListener('keydown', this.enableCapsAndNumLock);
	},
	beforeDestroy() {
		window.removeEventListener("keydown", this.enableCapsAndNumLock);
	},
	methods: {
		enableCapsAndNumLock(event) {
			if (!event || typeof event.getModifierState !== 'function')
			{
				return;
			}
			const target = event.target.id === this.idTarget;
			const isCapsLockActivated = event.getModifierState('CapsLock');
			const isNumLockActivated = event.getModifierState('NumLock');

			if (target) {
				this.isCapsLockOn = isCapsLockActivated
				this.isNumLockOn = isNumLockActivated;
			}
		}
	},
};
</script>
